<template>
  <el-drawer
    :title="detalleEmpresaNombre"
    :visible.sync="showDrawerDataCliente"
    :before-close="beforeClose"
    size="75%"
    :modal="false"
  >
    <el-card class="card">
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <!-- <el-button
            v-show="!loading_Balance_Data"
            type="primary"
            icon="el-icon-download"
            @click="exportReport"
            >Exportar</el-button
          > -->
          <!-- <el-col :span="10" :offset="1">
            <h2>
              Total:
              {{ $options.formatMonto(total) }}
              <i class="el-icon-coin"></i>
            </h2>
          </el-col> -->
          <!--<el-col :span="2" :offset="1">
            <h2>Cliente:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ CurrentClienData.clientName }}</b></strong
              >
            </h2>
          </el-col>-->
        </el-row>
      </div>
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-col :span="12"> </el-col>
          <el-col :span="12">
            <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="6" :offset="1">
                <!--<h4>filtro diferencias</h4>-->
              </el-col>
              <rabbey-toolbox
                filter-placeholder="Buscar por nombre"
                filterables
                @filter-search="search = $event"
              />
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <rabbey-table3
            ref="companyTable"
            :search="search"
            :border="true"
            :stripe="true"
            :columns="Columns"
            v-loading="loading_Balance_Data"
            :data="SupplierBalanceDataMaster"
            :actions="BalanceReportActions"
            @rtable-push-action="onActionSelected"
            :class-table="{
              'table-box': true,
              'card-base': true,
              'card-shadow--medium': false
            }"
            :show-summary="true"
            :pageSizes="[10, 20, 50, 100, 200, 500]"
            :summary-method="getSummariesEmpresa"
          />
        </el-row>
        <TotaldeConsumosDetail
          :key="detailConsumosKey"
          ref="totaldeConsumosDetail"
          :showDrawerTotalConsumos="showDrawerTotalConsumos"
          :CurrentClienData="ClientData"
          :ClienId="clientId"
          @closeTotal="OnCloseDetailTotalConsumos"
        />

        <RecargaTotalReportDetailed
          :key="detailRecargaKey"
          ref="RecargaTotalReportDetailed"
          :showDrawerRecarga="showDrawerRecarga"
          :CurrentClienData="ClientData"
          :ClientID="clientId"
          @OncloseDetail="OnCloseDetailRecarga"
        />
        <CxCDiferenceDetail
          :key="dialogCxCKey"
          ref="CxCDiferenceDetail"
          :DialogShow="dialogShow"
          :RowData="rowData"
          @OnDialogClose="onDialogClose"
        />
        <ClientBalanceReportDetailed
          :key="detailKey"
          ref="clientBalanceReportDetailed"
          :showDrawer="showClientBalanceReportDetailed"
          :CurrentClienData="ClientData"
          @OncloseDetail="OnCloseClientBalanceReportDetailed"
        />
        <ClientPagoProveedoresReport
          :key="detailKeyPagoProveedores"
          ref="clientPagoProveedoresReport"
          :showDrawer="showClientPagoProveedoresReport"
          :CurrentClienData="ClientData"
          @OncloseDetail="OnCloseClientPagoProveedoresReport"
        />
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import { Columns } from "/src/views/apps/ncfmovil/columnsTables/BalanceReportColumns.js";
import { formatMonto } from "@/utils";
import RecargaTotalReportDetailed from "@/views/apps/ncfmovil/Reports/Detailled_Reports/RecargaTotalReportDetailed.vue";
import CxCDiferenceDetail from "@/views/apps/ncfmovil/Reports/Detailled_Reports/CxCDiferenceDetail.vue";
import ClientBalanceReportDetailed from "@/views/apps/ncfmovil/Reports/Detailled_Reports/ClientBalanceReportDetailed.vue";
import TotaldeConsumosDetail from "@/views/apps/ncfmovil/Reports/Detailled_Reports/TotaldeConsumosDetail.vue";
import ClientPagoProveedoresReport from "@/views/apps/ncfmovil/Reports/Detailled_Reports/ClientPagoProveedoresReport.vue";

export default {
  name: "Columns",
  components: {
    RecargaTotalReportDetailed,
    CxCDiferenceDetail,
    ClientBalanceReportDetailed,
    TotaldeConsumosDetail,
    ClientPagoProveedoresReport
  },
  data() {
    return {
      Columns,
      SupplierBalanceDataMaster: [],
      loading_Balance_Data: false,
      loading_Data: false,

      showClientBalanceReportDetailed: false,
      showClientPagoProveedoresReport: false,
      showDrawerRecarga: false,
      showDrawerTotalConsumos: false,
      showDrawer: false,

      detailKey: 0,
      detailKeyPagoProveedores: -1,
      detailConsumosKey: 1,
      detailRecargaKey: 2,
      dialogCxCKey: 100,

      clientId: 0,
      rowData: {},
      ClientData: {},

      detalleEmpresaNombre: ""
    };
  },
  props: {
    showDrawerDataCliente: {
      type: Boolean,
      default: false
    },
    ClientID: {
      type: Number,
      default: 0
    },

    CurrentClienData: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.GetBalanceReportData(this.ClientID);
  },
  methods: {
    formatMonto,
    async GetBalanceReportData(ClientID = null) {
      this.loading_Balance_Data = true;
      this.loading_Data = true;
      await this.$http
        .get(`/api/tennos/GetSupplierBalanceReportMaster?EmpresaId=${ClientID}`)
        .then((resp) => {
          this.SupplierBalanceDataMaster = resp.data;
          this.SupplierBalanceDataMaster.forEach((client) => {
            client.OpenDetail = this.OpenDetail;
            client.OpenDetailTotalConsumos = this.OpenDetailTotalConsumos;
            client.OpenClientPagoProveedoresReport =
              this.OpenClientPagoProveedoresReport;
            client.OpenDetailRecarga = this.OpenDetailRecarga;
            client.OpenDetailCxCDiference = this.OpenDetailCxCDiference;
            this.detalleEmpresaNombre = `Lista de Clientes de ${this.CurrentClienData.nombre}`;
          });
          /*
          console.log(
            "SupplierBalanceDataMaster: ",
            this.SupplierBalanceDataMaster
          );
          */
        })
        .catch(() => {
          //console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
          this.loading_Data = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },

    beforeClose() {
      this.$emit("OncloseDetailCliente");
      //this.$emit("OncloseDetail");
    },
    OpenDetailTotalConsumos(row) {
      this.ClientData = row;
      this.clientId = row.clientid;
      this.showDrawerTotalConsumos = true;
      this.detailConsumosKey++;
    },
    OpenDetailRecarga(row) {
      this.ClientData = row;
      this.clientId = row.clientid;
      this.showDrawerRecarga = true;
      this.detailRecargaKey++;
    },
    OpenDetailCxCDiference(val) {
      this.rowData = val;
      this.dialogShow = true;
      this.dialogCxCKey++;
      console.log(this.dialogShow);
    },
    OpenDetail(row) {
      //console.log("funciona opendetail", row.clientid," ", row.supplierId);
      /*
      this.clientId = row.clientid;
      this.suplierId = row.supplierId;
      */
      this.ClientData = row;
      this.showClientBalanceReportDetailed = true;
      this.detailKey++;
    },
    OpenClientPagoProveedoresReport(row) {
      this.ClientData = row;
      this.showClientPagoProveedoresReport = true;
      this.detailKeyPagoProveedores--;
    },
    OnCloseClientBalanceReportDetailed() {
      this.showClientBalanceReportDetailed = false;
    },
    OnCloseClientPagoProveedoresReport() {
      this.showClientPagoProveedoresReport = false;
    },
    OnCloseDetailRecarga() {
      this.showDrawerRecarga = false;
      this.detailRecargaKey++;
    },
    OnCloseDetailTotalConsumos() {
      this.showDrawerTotalConsumos = false;
      this.detailConsumosKey++;
    },
    OnCloseDetail() {
      this.showDrawer = false;
    },
    getSummariesEmpresa(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 4 && index != 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  }
};
</script>
<style lang="css" scoped>
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
